import PropTypes from "prop-types"
import React, { useState, useEffect } from "react"
import { Row, Col, Collapse } from "reactstrap"
import { Link, withRouter } from "react-router-dom"
import classname from "classnames";
import { getProfile } from '../../store/auth/profile/actions';


//i18n
import { withTranslation } from "react-i18next"

import { connect } from "react-redux"

const Navbar = props => {
  const [dashboard, setdashboard] = useState(false)
  const [ui, setui] = useState(false)
  const [app, setapp] = useState(false)
  const [email, setemail] = useState(false)
  const [task, settask] = useState(false)
  const [component, setcomponent] = useState(false)
  const [form, setform] = useState(false)
  const [table, settable] = useState(false)
  const [chart, setchart] = useState(false)
  const [icon, seticon] = useState(false)
  const [map, setmap] = useState(false)
  const [extra, setextra] = useState(false);
  const { user, role } = props;

  useEffect(() => {
    var matchingMenuItem = null
    var ul = document.getElementById("navigation")
    var items = ul.getElementsByTagName("a")
    for (var i = 0; i < items.length; ++i) {
      if (props.location.pathname === items[i].pathname) {
        matchingMenuItem = items[i]
        break
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem)
    }
  })

  useEffect(()=>{
    getProfile();
  }, []);

  const getProfile = async () => {
    const user = JSON.parse(await localStorage.getItem("authUser"));
    // console.log('user from storage', user?.user);
    if (user)
      props.getProfile(user);
  }

  function activateParentDropdown(item) {
    item.classList.add("active")
    const parent = item.parentElement
    if (parent) {
      parent.classList.add("active") // li
      const parent2 = parent.parentElement
      parent2.classList.add("active") // li
      const parent3 = parent2.parentElement
      if (parent3) {
        parent3.classList.add("active") // li
        const parent4 = parent3.parentElement
        if (parent4) {
          parent4.classList.add("active") // li
          const parent5 = parent4.parentElement
          if (parent5) {
            parent5.classList.add("active") // li
            const parent6 = parent5.parentElement
            if (parent6) {
              parent6.classList.add("active") // li
            }
          }
        }
      }
    }
    return false
  }

  return (
    <React.Fragment>
      <div className="topnav">
        <nav
          className="navbar navbar-light navbar-expand-lg topnav-menu"
          id="navigation"
        >
          <Collapse
            isOpen={props.leftMenu}
            className="navbar-collapse"
            id="topnav-menu-content"
          >
            <ul className="navbar-nav">
              {/* <li className="nav-item dropdown">
                <Link
                  className="nav-link dropdown-toggle arrow-none"
                  to="/dashboard"
                >
                  {props.t("Dashboard")}{" "}
                </Link>
              </li> */}
              {/* {role == 'Admin' && */}
                {/* <>                  
                  <li className="nav-item dropdown">
                    <Link
                      to="/slot"
                      className="nav-link dropdown-toggle arrow-none"
                    >
                      {props.t("Slot")}
                    </Link>
                  </li>
                  <li className="nav-item dropdown">
                    <Link
                      to="/booking"
                      className="nav-link dropdown-toggle arrow-none"
                    >
                      {props.t("Booking")}
                    </Link>
                  </li>
                  <li className="nav-item dropdown">
                    <Link
                      to="/users"
                      className="nav-link dropdown-toggle arrow-none"
                    >
                      {props.t("Patient")}
                    </Link>
                  </li>
                </>
              } */}
            </ul>
          </Collapse>
        </nav>
      </div>
    </React.Fragment>
  )
}

Navbar.propTypes = {
  leftMenu: PropTypes.any,
  location: PropTypes.any,
  menuOpen: PropTypes.any,
  t: PropTypes.any,
  getProfile: PropTypes.func
}

const mapStatetoProps = state => {
  const { leftMenu } = state.Layout;
  return { leftMenu, user: state.Profile?.user }
}

export default withRouter(
  connect(mapStatetoProps, { getProfile })(withTranslation()(Navbar))
)